import { jsx as C, jsxs as t } from "react/jsx-runtime";
import "react";
var e = (r) => /* @__PURE__ */ t("svg", {
  width: 34,
  height: 30,
  viewBox: "0 0 34 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...r,
  children: [/* @__PURE__ */ C("path", {
    d: "M28 4H6V18.25L6.00586 18.374C6.03436 18.66 6.1612 18.9288 6.36621 19.1338C6.60063 19.3682 6.91848 19.5 7.25 19.5H26.75C27.0815 19.5 27.3994 19.3682 27.6338 19.1338C27.8682 18.8994 28 18.5815 28 18.25V4ZM32 18.25C32 19.6424 31.4465 20.9773 30.4619 21.9619C29.4773 22.9465 28.1424 23.5 26.75 23.5H19V26H21.875C22.9796 26 23.875 26.8954 23.875 28C23.875 29.1046 22.9796 30 21.875 30H12.125C11.0204 30 10.125 29.1046 10.125 28C10.125 26.8954 11.0204 26 12.125 26H15V23.5H7.25C5.85761 23.5 4.52265 22.9465 3.53809 21.9619C2.55352 20.9773 2 19.6424 2 18.25V3.96289C1.07486 3.78722 0.375 2.97627 0.375 2C0.375 0.89543 1.27043 0 2.375 0H31.625C32.7296 0 33.625 0.89543 33.625 2C33.625 2.97627 32.9251 3.78722 32 3.96289V18.25Z",
    fill: "currentColor"
  }), /* @__PURE__ */ C("path", {
    d: "M22.0859 7.08579C22.867 6.30474 24.133 6.30474 24.914 7.08579C25.6951 7.86684 25.6951 9.13286 24.914 9.91391L20.039 14.7889C19.258 15.57 17.992 15.57 17.2109 14.7889L15.375 12.953L11.914 16.4139C11.133 17.195 9.86696 17.195 9.08591 16.4139C8.30486 15.6329 8.30486 14.3668 9.08591 13.5858L13.9609 8.71079L14.1123 8.57309C14.8978 7.9323 16.0568 7.97852 16.789 8.71079L18.625 10.5467L22.0859 7.08579Z",
    fill: "currentColor"
  })]
});
export {
  e as default
};
